import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

{
  /* <Box sx={{ display: "flex", gap: 1, justifyContent: 'space-between',flexDirection:'column',marginLeft:10}}>
<StatCard title="יחידות קצה" value={4264} width={316} />
<Box sx={{ display: "flex", gap: 2, justifyContent: 'center', }}>
  <StatCard title="משימות פתוחות" value={13} />
  <StatCard title="משימות בביצוע" value={8} />
</Box>
</Box> */
}

type StatCardProps = {
  onClick?: () => void
  title: string
  value: string | number
  borderColor?: string
  width?: string | number
  height?: string | number
}

const StatCard: React.FC<StatCardProps> = ({
  onClick,
  title,
  value,
  borderColor: propBorderColor,
  width = 150,
  height = 150,
}) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  // Theme-aware colors
  const colors = {
    background: isDarkMode ? '#202B40' : '#FAFBFD',
    border: isDarkMode ? '#374151' : (propBorderColor || '#323B771A'),
    text: isDarkMode ? '#BBD7FF' : '#003F61',
  }

  return (
    <Box
      onClick={onClick}
      sx={{
        border: `1.2px solid ${colors.border}`,
        borderRadius: '8px',
        padding: '16px',
        textAlign: 'center',
        minWidth: 150,
        width,
        height,
        backgroundColor: colors.background,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Rubik, sans-serif',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'background-color 0.3s ease, border-color 0.3s ease',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: colors.text,
          fontWeight: 200,
          fontSize: 16,
          fontFamily: 'Rubik, sans-serif',
          textAlign: 'center',
          width: '100%',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          color: colors.text,
          fontWeight: 500,
          fontSize: 25,
          fontFamily: 'Rubik, sans-serif',
          textAlign: 'center',
          width: '100%',
        }}
      >
        {value}
      </Typography>
    </Box>
  )
}

export default StatCard
